import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import authReducer from "./slices/authState";
import transactionsReducer from "./slices/transactionState";
import partiesReducer from "./slices/partyState";
import driversReducer from "./slices/driverState";
import vehicleReducer from "./slices/vehicleState";
import createSagaMiddleware from "redux-saga";

import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

import transactionSaga from "./saga/transactionSaga";
import partySaga from "./saga/partySaga";
import ledgerSaga from "./saga/ledgerSaga";
import driverSaga from "./saga/driverSaga";
import vehicleSaga from "./saga/vehicleSaga";

const persistConfig = {
  key: "authentication",
  storage: storageSession,
  blacklist: [],
};
const reducers = combineReducers({
  auth: authReducer,
  transactions: transactionsReducer,
  parties: partiesReducer,
  drivers: driversReducer,
  vehicles: vehicleReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);
const saga = createSagaMiddleware();

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(saga),
});

saga.run(transactionSaga);
saga.run(partySaga);
saga.run(ledgerSaga);
saga.run(driverSaga);
saga.run(vehicleSaga);
